module.exports = __webpack_public_path__ + "static/media/edit.9e96c28d.svg";